export const filters = {
	Sort: {
		k: "refine.sort",
		v: "Sort"
	},

	Currency: {
		k: "currency.filter",
		v: "Currency Type"
	},

	LoadMore: {
		k: "messages.loadmore",
		v: "Load More"
	},
	CompletionStatus: {
		k: "refine.completions",
		v: "Completion Status"
	}
};



// WEBPACK FOOTER //
// ./src/common/Labels/Refine.ts